import { css } from '@emotion/css';
import colors from '@/theme/colors';
import { pxToRem } from '@/utils';

const styles = {
  chip: css`
    color: ${colors.prussianMid};
    font-size: ${pxToRem(12)};
    padding: 2px 8px;
    border-radius: ${pxToRem(10)};
    letter-spacing: 0.4px;
    font-weight: 600;
    font-family: 'Montserrat Medium', Arial, Helvetica, sans-serif;
  `,
  variants: {
    default: css`
      background: ${colors.prussian300};
      color: ${colors.prussian};
    `,
    danger: css`
      color: ${colors.red};
      background: ${colors.rose};
    `,
    rose: css`
      background: #fde3e6;
      color: #f01833;
    `,
    success: css`
      color: #3a833c;
      background: #c5e8c9;
    `,
    expired: css`
      color: #ac0b1f;
      background: #f5e5de;
    `,
  },
};

export default styles;
